module.exports = __webpack_public_path__ + "media/images/home/uber-511a6942e4c82c2a2d7ba91fe37afec3.png";